import { ls } from '../utility/local-storage';
import { formatDate } from '../utility/date';
import { SHOWN_MESSAGES_STORAGE_KEY } from '../constants';
import { Message } from './message';

interface StoreKeyOption {
  idfv: string;
  userAnnotation: string;
}
interface PersistenceParams extends StoreKeyOption {
  token: string;
}

let isStoreDisabled: boolean = false;

class Persistence {
  public static hasBeenDisplayed({ idfv, userAnnotation, token }: PersistenceParams, message: Message): boolean {
    const key = Persistence.storeKey({ idfv, userAnnotation });
    const messagesByKey = Persistence.storedShownMessages({ idfv, userAnnotation, token })[key];
    const shownMessage = messagesByKey[message.messageId];

    if (shownMessage) return true;

    // messageIdによる重複排除のみでは、サーバーサイドの実装に不備があり同じユーザーに異なるmessageIdのメッセージが表示される可能性があるため
    // variantGroupIdによる重複排除用に、過去に表示したメッセージのvariantGroupIdもチェックする

    // TODO: msg に型をつける
    return Object.values(messagesByKey).some((msg: FIXME) => {
      // 何かが間違ってundefinedや空文字で variant_group_id が保存されていたりconfigで返ってきていると
      // msg.variant_group_id === message.variantGroupId の比較式が真になってしまうため、値があることを先にチェックする
      if (!msg.variant_group_id || !message.variantGroupId) return true;
      return msg.variant_group_id === message.variantGroupId;
    });
  }

  public static storeShownMessage({ idfv, userAnnotation, token }: PersistenceParams, message: Message): void {
    if (isStoreDisabled) return;
    if (idfv == null || userAnnotation == null || token == null) return;

    const key = Persistence.storeKey({ idfv, userAnnotation });
    const val = Persistence.storedShownMessages({ idfv, userAnnotation, token });

    val[key][message.messageId] = {
      id: message.messageId,
      variant_group_id: message.variantGroupId,
      tracked_at: formatDate(new Date()),
    };
    ls.set(SHOWN_MESSAGES_STORAGE_KEY(token), JSON.stringify(val));
  }

  public static clearShownMessages(token: string): void {
    ls.remove(SHOWN_MESSAGES_STORAGE_KEY(token));
  }

  public static disableStorage(): void {
    isStoreDisabled = true;
  }

  private static storeKey({ idfv, userAnnotation }: StoreKeyOption): string {
    return userAnnotation !== '' ? userAnnotation : idfv;
  }

  // TODO: 返り値の型構造考える
  private static storedShownMessages({ idfv, userAnnotation, token }: PersistenceParams): FIXME {
    try {
      // TODO: ls.get は nullable なので、ここのロジックもどこかで厳密なものにしたい
      const val = JSON.parse(ls.get(SHOWN_MESSAGES_STORAGE_KEY(token)) as string) || {};

      // Migrating to user object if not in SHOWN_MESSAGES_STORAGE or create new Object if null
      // Before: rpr_shown_messages:${token} = [{ messages }]
      // After: rpr_shown_messages:${token} = [{userId: [{ messages }]]

      // TODO: やってること以上にコードが複雑であるので、コードバラす
      if (userAnnotation === '' && !val[idfv]) {
        val[idfv] = {};
        ls.set(SHOWN_MESSAGES_STORAGE_KEY(token), JSON.stringify(val));
      } else if (userAnnotation !== '' && !val[userAnnotation]) {
        val[userAnnotation] = {};
        ls.set(SHOWN_MESSAGES_STORAGE_KEY(token), JSON.stringify(val));
      }
      return val;
    } catch (_) {
      return {};
    }
  }

  public static migrateIdfv(oldIdfv: string, newIdfv: string, token: string): void {
    const oldVal = JSON.parse(ls.get(SHOWN_MESSAGES_STORAGE_KEY(token)) as string) || {};

    const newVal = {} as Record<string, any>;
    Object.entries(oldVal).forEach(([k, v]) => {
      if (k === oldIdfv) {
        newVal[newIdfv] = v;
      } else {
        newVal[k] = v;
      }
    });

    ls.set(SHOWN_MESSAGES_STORAGE_KEY(token), JSON.stringify(newVal));
  }
}

export { Persistence as MessagePersistence };
